import styled from '@emotion/styled';
import { sideGutterWidth } from '../../styles/constants';
import { primaryFontFamily } from '../../styles/fonts';
import { boxShadow } from '../../styles/mixins';
import { minDeviceWidth } from '../../styles/responsive';
import Collapse from '../Collapse';

export const PageWrapper = styled.div`
  box-sizing: border-box;

  margin-right: 0px;
  margin-left: 0px;

  @media ${minDeviceWidth('tablet')} {
    margin-right: ${sideGutterWidth.tablet}px;
    margin-left: ${sideGutterWidth.tablet}px;
  }
  @media ${minDeviceWidth('desktop')} {
    margin: 0px;
  }
`;

export const Container = styled.div`
  ${primaryFontFamily}
  background-color: ${({ theme }) => theme.default.colors.n0};
  border-radius: 4px;
  margin-bottom: 24px;

  @media ${minDeviceWidth('tablet')} {
    ${boxShadow}
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  column-gap: 16px;
  padding: 24px 16px;

  @media ${minDeviceWidth('mobile-landscape')} {
    padding: 24px;
  }

  & .date {
    display: none;

    @media ${minDeviceWidth('mobile-landscape')} {
      display: block;
    }
  }
`;

export const Content = styled.div`
  border-top: 1px dashed ${({ theme }) => theme.default.colors.n2};
`;

export const Segment = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-shrink: 0;
`;

export const StyledCollapse = styled(Collapse)`
  transition: height ${({ theme }) => theme.default.timings.base}ms ease-out;
`;
